import React, { Component } from 'react';
import { connect } from 'react-redux';
import Modal from '../Modal';
import * as modal from '../../reducers/modalReducer';
import ProductShort from '../ProductShort';
import { addProduct, cartUpdated } from '../../reducers/cartReducer'

import './style.css'

class ProductModal extends Component {
 
  // this.props.product
  // this.props.index
  
  // product size index
  // product quantity

  isAddToCart: false;

  onCloseRequest = () => {
    if (this.isAddToCart) return;
    this.props.hideModal();
  }
  handleAddToCartClick = (product) => {
    this.isAddToCart = true;
    this.props.addProduct(product);
    this.props.openItemAdded()
  }

  handleClose = () => {
    this.props.hideModal();
  }
 
  render() {
    return (
      <Modal modalType={this.props.modalType} overlayTop={0} wrapperTop={'250px'} closeOnOverlayClick={true} closeOnOutsideClick={false} isOpened={true}  onClose={this.onCloseRequest}>
        <div className="greetigs" style={{height: '100%'}}>
          <ProductShort 
            onAddToCartClick={this.handleAddToCartClick} 
            product={this.props.product} 
            handleClose={this.handleClose}
          />
        </div>
       </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    modalType: state.modal.modalType,
    textColor : state.config.textColor,
    primaryColor: state.config.primaryColor,
    secondaryColor: state.config.secondaryColor,
  };
};

const mapDispatchToProps = (dispatch) => {
  return { 
      hideModal: () => dispatch(modal.hideModal()),
      addProduct: (product) => {
        dispatch(addProduct(product));
        dispatch(cartUpdated());
      },
      openItemAdded: () => dispatch(modal.openModal({
          modalType: 'ITEM_ADDED_FORM',
          modalProps: {}
        })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductModal);


// WEBPACK FOOTER //
// ./src/components/ProductModal/ProductModal.jsx